
import Vue from 'vue'
import BackgroundLayout from '@/components/BackgroundLayout.vue'
import {AboutUs} from "@/model/AboutUs";

export default Vue.extend({
  name: 'AboutUs',
  components: {
    BackgroundLayout,
  },
  props: {
    slug: {
      type: String,
    },
  },
  mounted() {
    this.fetch()
  },
  data: () => ({
    aboutUs: null as AboutUs | null,
  }),
  methods: {
    fetch: function () {
      this.$api
        .get('/contents/about-us')
        .then((response) => {
          this.aboutUs = response.data
        })
        .catch(() => this.$router.push('/404'))
    },
  },
  watch: {
    $route: function () {
      this.fetch()
    },
  },
})
